const getUserSlice = (state) => state.user;

export const getUserProfile = (state) => getUserSlice(state).profile;
export const getIsLoading = (state) => getUserSlice(state).loading;
export const getIsPageLoading = (state) => getUserSlice(state).pageLoading;
export const getCustomToken = (state) => getUserSlice(state).customToken;
export const getCustomTokenLoading = (state) => getUserSlice(state).customTokenLoading;

/**
 * True when customToken is loaded and ready for use in portal-v3 navigation.
 * Components that build URLs with ?token= should check this before redirecting.
 * After F5 (page refresh), Firebase session survives in IndexedDB but customToken
 * is lost from Redux — this selector prevents navigation with an empty token
 * while signInUser() refetches it from GET /user/current.
 */
export const isCustomTokenReady = (state) =>
  !getUserSlice(state).customTokenLoading && !!getUserSlice(state).customToken;
